var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"form-control select2",staticStyle:{"width":"100%"},attrs:{"multiple":"multiple"}},_vm._l((_vm.data),function(item,index){return _c('option',{key:index,attrs:{"data":item},domProps:{"selected":item.selected,"value":item.id}},[_vm._v("\n      "+_vm._s(_vm.$t(item.text)))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f81f25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LTESelect2Section.vue
// module id = null
// module chunks = 